export { default } from './EnNavbar.vue';
export { default as EnNavbar } from './EnNavbar.vue';
